import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import MemberList from './MemberList';
import CustomerList from './CustomerList';
import MemberFormModal from './MemberFormModal';
import CustomerFormModal from './CustomerFormModal';
import './MemberCard.css';

type TabType = 'members' | 'customers';

const MemberCustomerPage: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialTab = (searchParams.get('tab') as TabType) || 'members';
  const [activeTab, setActiveTab] = useState<TabType>(initialTab);
  const [showMemberForm, setShowMemberForm] = useState(false);
  const [showCustomerForm, setShowCustomerForm] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleTabChange = (tab: TabType) => {
    setActiveTab(tab);
    setSearchParams(tab === 'members' ? {} : { tab });
  };

  const handleMemberSaved = () => {
    setRefreshKey(k => k + 1);
  };

  const handleCustomerSaved = () => {
    setRefreshKey(k => k + 1);
  };

  const getCorporateCode = (): string | number => {
    const userData = localStorage.getItem('managerUserData');
    if (userData) {
      const parsed = JSON.parse(userData);
      return parsed.corporate_code || parsed.corporate_id || '';
    }
    return '';
  };

  const getStoreId = (): number => {
    const userData = localStorage.getItem('managerUserData');
    if (userData) {
      return JSON.parse(userData).store_id || 0;
    }
    return 0;
  };

  return (
    <div className="member-list-page">
      <div className="member-list-header">
        <h1 className="page-title">
          {activeTab === 'members' ? 'Members' : 'Customers'}
        </h1>
        <button
          className="btn btn-primary"
          onClick={() => activeTab === 'members' ? setShowMemberForm(true) : setShowCustomerForm(true)}
        >
          {activeTab === 'members' ? '+ Add Member' : '+ Add Customer'}
        </button>
      </div>

      <div className="tab-bar">
        <button
          className={`tab-button ${activeTab === 'members' ? 'tab-button--active' : ''}`}
          onClick={() => handleTabChange('members')}
        >
          Members
        </button>
        <button
          className={`tab-button ${activeTab === 'customers' ? 'tab-button--active' : ''}`}
          onClick={() => handleTabChange('customers')}
        >
          Customers
        </button>
      </div>

      <div key={refreshKey}>
        {activeTab === 'members' ? <MemberList /> : <CustomerList />}
      </div>

      <MemberFormModal
        isOpen={showMemberForm}
        onClose={() => setShowMemberForm(false)}
        onSaved={handleMemberSaved}
        corporateCode={getCorporateCode()}
      />

      <CustomerFormModal
        isOpen={showCustomerForm}
        onClose={() => setShowCustomerForm(false)}
        onSaved={handleCustomerSaved}
        storeId={getStoreId()}
      />
    </div>
  );
};

export default MemberCustomerPage;
